import { Select, InputNumber, DatePicker } from "antd";
import React from "react";
import { MetadataDefinition } from "src/modules/administration/types/Metadata";
import { Utils } from "src/modules/common/misc/Utils";
import { TasksFiltersVisualStore } from "../stores";
import { observer } from "mobx-react-lite";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

type Props = {
    filterStore: TasksFiltersVisualStore;
    metadata?: MetadataDefinition;
    isAppliedFilter?: boolean;
};

export const NumericFilterOptions = {
    Equal: "is equal to",
    NotEqual: "is not equal to",
    IsGreaterThen: "is greater than",
    IsLessThen: "is less than",
    Empty: "is empty",
};

const MetadataFilterControls: React.FC<Props> = ({
    filterStore,
    metadata,
    isAppliedFilter = false,
}) => {
    let widget: React.ReactElement;
    if (!metadata) {
        return null;
    }
    const columnName = metadata.id;

    switch (metadata.fieldType) {
        case "Text":
            widget = (
                <Select
                    autoFocus={isAppliedFilter}
                    className="metadata-filter-value-select"
                    mode="tags"
                    style={isAppliedFilter ? undefined : { width: 200 }}
                    suffixIcon={isAppliedFilter ? null : undefined}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    onKeyDown={(e) => {
                        if (isAppliedFilter) {
                            e.stopPropagation();
                        }
                    }}
                    value={
                        filterStore.columnsFilterDict[columnName]?.value || []
                    }
                    onChange={(val) =>
                        filterStore.setCurrentFilterValue(columnName, val, true)
                    }
                    placeholder="Enter value"
                />
            );
            break;
        case "Number":
            widget = (
                <div className="numeric-widget">
                    <InputNumber
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onPressEnter={(e) => {
                            const target = e.target as HTMLInputElement;
                            const val = parseFloat(target.value);
                            if (!isNaN(val)) {
                                filterStore.setCurrentFilterValue(
                                    columnName,
                                    [val],
                                    true,
                                );
                            }
                        }}
                        value={
                            filterStore.columnsFilterDict[columnName]?.value[0]
                        }
                        placeholder="Enter value"
                    />
                </div>
            );
            break;
        case "Boolean": {
            const { trueVal, falseVal } = metadata.format
                ? JSON.parse(metadata.format)
                : { trueVal: "true", falseVal: "false" };
            widget = (
                <Select
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    options={[
                        {
                            label: trueVal || "true",
                            value: true,
                        },
                        {
                            label: falseVal || "false",
                            value: false,
                        },
                    ]}
                    onChange={(val) =>
                        filterStore.setCurrentFilterValue(
                            columnName,
                            [val],
                            true,
                        )
                    }
                    value={
                        filterStore.columnsFilterDict[columnName]?.value || null
                    }
                    placeholder="Select value"
                />
            );
            break;
        }
        case "DateTime":
            widget = (
                <RangePicker
                    onChange={(val) =>
                        filterStore.setCurrentFilterValue(
                            columnName,
                            val?.map((v) => v?.hour(0).minute(0).second(0)) ||
                                [],
                            true,
                        )
                    }
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    value={
                        filterStore.columnsFilterDict[columnName]?.value.map(
                            (m) => dayjs(new Date(m)),
                        ) as never
                    }
                    format={Utils.getDateFormat()}
                />
            );
            break;
        default:
            widget = <></>;
    }
    return widget;
};

export default observer(MetadataFilterControls);
